(function () {
    if ($('#country-search').length === 0) return;

    var countrySearch, $countrySearch;
    var locationSearch, $locationSearch;
    var querystring = require('../modules/Querystring');
    var xhr;

    $.get('/api/countries', function (countries) {
        if (!countries.length) return;

        $countrySearch = $('#country-search').selectize({
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            sortField: 'name',
            selectOnTab: true,
            options: countries,
            onChange: function (value) {
                if (!value.length) return;

                // If they select worldwide, show a message and send them to the master site
                if (value == 0) {
                    window.location.replace('/redirect/worldwide');

                    return;
                }

                if ($('.hero').css('background-image') !== 'none') {
                    $('.discover-background').css('background-image', 'url(../images/location-backgrounds/' + value + '.jpg)');
                    $('.discover-background').addClass('active');
                }

                $(document).trigger('countryChanged', {
                    id: value,
                });

                locationSearch.disable();
                locationSearch.clearOptions();
                locationSearch.load(function (callback) {
                    xhr && xhr.abort();

                    xhr = $.ajax({
                        url: '/api/locations?country_id=' + value,
                        method: 'GET',
                        success: function (results) {
                            locationSearch.enable();

                            setTimeout(function () {
                                var location = querystring.get('location');

                                if (location) {
                                    locationSearch.setValue(location);
                                } else {
                                    locationSearch.setValue($('input[name="location_id"]').val());
                                }

                                $(document).trigger('dataLoaded');
                            }, 0);

                            $.each(results, function (key, value) {
                                if (value) {
                                    value.name = htmlDecode(value.name);
                                }
                            });

                            callback(results);
                        },
                        error: function () {
                            callback();
                        },
                    });
                });
            },
        });

        countrySearch = $countrySearch[0].selectize;

        var country = querystring.get('country');

        if (country) {
            countrySearch.setValue(country);
        } else {
            countrySearch.setValue($('input[name="country_id"]').val());
        }
    });

    $locationSearch = $('#location-search').selectize({
        valueField: 'id',
        labelField: 'name',
        searchField: 'name',
        sortField: 'name',
        selectOnTab: true,
    });

    locationSearch = $locationSearch[0].selectize;

    locationSearch.disable();

    // Ugliest hack ever
    function htmlDecode(str) {
        var div = document.createElement('div');

        div.innerHTML = str;

        return $(div).text();
    }
})();
